/* PagingImagesFeed.js */

const PagingFeed = require("../../../../../../../lib/PagingFeed");

class PagingImagesFeed extends PagingFeed {
    _getFeed() {
        return this._EntityDef.startRelatedOsImagesFeed(
            {},
            {},
            {},
            {
                skip: 0,
                limit: 200
            }
        );
    }
    _feedReestablish() {
        return this._feed.reestablishFeed(this._activeOrgId, {}, this._entityFields, this._sort);
    }
}

module.exports = PagingImagesFeed;
